<template>
  <div v-if="!readonly">
    <el-form :model="order" label-position="top" require-asterisk-position="right">
      <div class="flex-container">
        <el-form-item :label="$t('components.product-parameter.balcony.orientation-type')">
          <el-radio-group id="orientation" v-model="order.orientationType" size="large" class="radio-Button">
            <el-radio-button v-for="orientationType in Object.values(OrientationType)" :key="orientationType" :value="orientationType">
              <el-tooltip placement="top">
                <template #content>
                  <img class="parameter-img" :src="getImageSrc(orientationType)" alt="Orientation" />
                </template>
                <span>{{ $t(`enum.orientationType.${orientationType}`) }}</span>
              </el-tooltip>
            </el-radio-button>
          </el-radio-group>
        </el-form-item>

        <el-form-item :label="$t('components.product-parameter.balcony.carrying-out')">
          <el-select v-model="order.balconyType" class="select-component" :placeholder="Object.values(BalconyType).at(0)">
            <el-option v-for="balconyType in Object.values(BalconyType)" :key="balconyType" :value="balconyType" :label="$t(`enum.balconyType.${balconyType}`)">
              <!-- Wrap your content in a container with a custom class -->
              <div class="option-label">
                <span>{{ $t(`enum.balconyType.${balconyType}`) }}</span>
                <img
                  class="option-image"
                  :src="getImageSrc(balconyType)"
                  alt="Orientation"
                  style="width: 45px; margin-left: 8px"
                />
              </div>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('components.product-parameter.balcony.paneel-type')">
          <el-radio-group id="panelType" v-model="order.paneelType" size="large" class="radio-Button">
            <el-radio-button v-for="paneelType in Object.values(PaneelType)" :key="paneelType" :value="paneelType">
              <el-tooltip placement="top">
                <template #content>
                  <img class="parameter-img" :src="getImageSrc(paneelType)" alt="Orientation" />
                </template>
                <span>{{ $t(`enum.paneelType.${paneelType}`) }}</span>
              </el-tooltip>
            </el-radio-button>
          </el-radio-group>
        </el-form-item>

        <el-form-item :label="$t('components.product-parameter.balcony.mounting-type')">
          <el-radio-group id="mountingType" v-model="order.mountingType" size="large" class="radio-Button">
            <el-radio-button v-for="mountingType in Object.values(MountingType)" :key="mountingType" :value="mountingType">
              <el-tooltip placement="top">
                <template #content>
                  <img class="parameter-img" :src="getImageSrc(mountingType)" alt="Orientation" />
                </template>
                <span>{{ $t(`enum.mountingType.${mountingType}`) }}</span>
              </el-tooltip>
            </el-radio-button>
          </el-radio-group>
        </el-form-item>
      </div>

      <el-form-item :label="$t('components.order-form.width')">
        <el-slider v-model.number="order.calfCircumferenceWithoutDeduction" :min="0" :max="20000" />
        <el-input-number v-model.number="order.calfCircumferenceWithoutDeduction" class="number-input-component" :min="0" :max="20000" />
      </el-form-item>

<!--       <el-form-item :label="$t('components.order-form.height')">
        <el-slider v-model.number="order.heightWithoutDeduction" :min="0" :max="20000" disabled />
        <el-input-number v-model.number="order.heightWithoutDeduction" class="number-input-component" :min="0" :max="20000" disabled />
      </el-form-item> -->

      <el-form-item v-if="order.balconyType !== BalconyType.straight" :label="$t('components.order-form.depth-left')">
        <el-slider v-model.number="order.depth" :min="0" :max="20000" />
        <el-input-number v-model.number="order.depth" class="number-input-component" :min="0" :max="20000" />
      </el-form-item>

      <el-form-item v-if="order.balconyType == BalconyType.uForm" :label="$t('components.order-form.depth-right')">
        <el-slider v-model.number="order.depthRight" :min="0" :max="20000" />
        <el-input-number v-model.number="order.depthRight" class="number-input-component" :min="0" :max="20000" />
      </el-form-item>
    </el-form>
  </div>
  <div v-else>
    <div class="row1">
      <label class="col-sm-6 form-label text-secondary">{{ $t('components.product-parameter.balcony.orientation-type') }}</label>
      <label class="col-sm-6 form-label">{{ $t(`enum.orientationType.${order?.orientationType}`) }}</label>
    </div>
    <div class="row1">
      <label class="col-sm-6 form-label text-secondary">{{ $t('components.product-parameter.balcony.carrying-out') }}</label>
      <label class="col-sm-6 form-label">{{ $t(`enum.balconyType.${order?.balconyType}`) }}</label>
    </div>
    <div class="row1">
      <label class="col-sm-6 form-label text-secondary">{{ $t('components.product-parameter.balcony.paneel-type') }}</label>
      <label class="col-sm-6 form-label">{{ $t(`enum.paneelType.${order?.paneelType}`) }}</label>
    </div>
    <div class="row1">
      <label class="col-sm-6 form-label text-secondary">{{ $t('components.product-parameter.balcony.mounting-type') }}</label>
      <label class="col-sm-6 form-label">{{ $t(`enum.mountingType.${order?.mountingType}`) }}</label>
    </div>
    <div class="row1">
      <label class="col-sm-6 form-label text-secondary">{{ $t('components.order-form.width') }}</label>
      <label class="col-sm-6 form-label">{{ order?.calfCircumferenceWithoutDeduction }}</label>
    </div>
    <div class="row1">
      <label class="col-sm-6 form-label text-secondary">{{ $t('components.order-form.height') }}</label>
      <label class="col-sm-6 form-label">{{ order?.heightWithoutDeduction }}</label>
    </div>
    <div v-if="order.fenceType !== FenceType.straight" class="row1">
      <label class="col-sm-6 form-label text-secondary">{{ $t('components.order-form.depth-left') }}</label>
      <label class="col-sm-6 form-label">{{ order?.depth }}</label>
    </div>
    <div v-if="order.fenceType == FenceType.uForm" class="row1">
      <label class="col-sm-6 form-label text-secondary">{{ $t('components.order-form.depth-right') }}</label>
      <label class="col-sm-6 form-label">{{ order?.depthRight }}</label>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Emit, Prop, Ref } from 'vue-facing-decorator';
import { BalconyType, FenceType, MountingType, OrientationType, PaneelType } from '@/types/enum/order';
import { ElForm } from 'element-plus';
import { OrderData } from '@/types/interfaces/orderData';

@Component({
  components: {},
  emits: ['sizeChanged'],
})
export default class ProductParamterFence extends Vue {
  @Prop() order!: OrderData;
  @Prop() product!: string;
  @Prop({ default: false }) readonly!: boolean;

  @Ref('formRef') formRef!: InstanceType<typeof ElForm>;
  FenceType = FenceType;
  BalconyType = BalconyType;
  MountingType = MountingType;
  PaneelType = PaneelType;
  OrientationType = OrientationType;

  getImageSrc(type: string) {
    const images = import.meta.glob('@/assets/images/balcony/*.png', { eager: true });
    return (images[`/src/assets/images/balcony/${type}.png`] as any)?.default || '';
  }

  depthConnected = false;

  mounted(): void {
    try {
      if (this.product === 'fence') {
        this.order.depth = 1950;
        this.order.depthRight = 1950;
        this.order.mountingType = MountingType.bottom;
        this.order.fenceType = FenceType.straight;
      }
    } catch (error) {
      console.error('error mounted fence', error);
    }
  }

  @Emit('isValid')
  async validateForm(): Promise<boolean> {
    if (!this.formRef) {
      return false;
    }

    try {
      const valid = await this.formRef.validate();
      return valid;
    } catch (error) {
      console.warn('Form validation error fence:', error);
      return false;
    }
  }
}
</script>

<style scoped lang="scss">
.text-secondary {
  color: #0000008d !important;
  text-align: left !important;
}

.row1 {
  border-bottom: 0.1rem solid #6767678d;
}

.form-label {
  font-size: 1rem;
  margin: 0.7rem 0 0.5rem 0;
  text-align: right;
}
.parameter-img {
  padding-top: 12px;
  width: 100px;
  height: 100px;
}
.disabled-hover .radio-label {
  transition: color 0.3s ease-in-out;
}
.disabled-hover:hover .radio-label {
  color: red;
  cursor: not-allowed;
}
.disabled-hover .radio-label {
  color: inherit;
  transition: color 0.3s ease-in-out;
}
</style>
